import { Box, Typography } from "@sidelinesports/fan-design-system";
import { LoadErrorVector } from "../../../assets/index.ts";
import {
  FullscreenLayout,
  IllustratedMessage,
} from "../../../components/index.tsx";

export const NoUserIdMessage = () => (
  <FullscreenLayout>
    <IllustratedMessage illustration={<LoadErrorVector />}>
      <Box background="white" p={40} borderRadius={8}>
        <Typography size="lg">
          Authentication error: no user id supplied. This is an integration
          misconfiguration, not an application error.
        </Typography>
      </Box>
    </IllustratedMessage>
  </FullscreenLayout>
);
